import { useProtected } from "@/hooks";
import { Outlet } from "react-router-dom";

export const IntegrationsRoot = () => {
  useProtected();

  return <Outlet />;
};
